import React, { Component } from 'react'
import { func, string } from 'prop-types'
import 'react-intl-tel-input/dist/libphonenumber.js'
import 'react-intl-tel-input/dist/main.css'
import { view } from '../../../stores'
import { translate } from 'react-i18next'
import { Loader } from '../states/Loader'
import api from '../../../api'

export class CouponCodeInputComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      errorMessage: null,
      code: '',
      isLoading: false,
      couponCode: null
    }
  }

  loadCouponCode (value) {
    const { t, onChange } = this.props
    api.couponCode.getByCode({ code: value }).then((response) => {
      this.setState({
        couponCode: response,
        errorMessage: null
      })
      onChange(response.id)
    }).catch((e) => {
      if (e.response.data.error === 'COUPON_CODE_NOT_FOUND') {
        this.setState({
          errorMessage: t('common:fields:noCouponCodeFound'),
          couponCode: null
        })
      } else {
        this.setState({ couponCode: null })
      }
      onChange(null)
    }).finally(() => {
      this.setState({ isLoading: false })
    })
  }

  handleChange (value) {
    clearTimeout(this._debouncer)
    if (value.length) {
      this.setState({ isLoading: true, couponCode: null })
      this._debouncer = setTimeout(() => {
        this.loadCouponCode(value)
      }, 1000)
    } else {
      this.setState({
        errorMessage: null,
        code: '',
        isLoading: false,
        couponCode: null
      })
      this.props.onChange(null)
    }
  }

  render () {
    const { isLoading, errorMessage } = this.state
    const { t } = this.props

    return (
      <div>
        <div className="clearfix">
          <label className={errorMessage ? 'form__label form__label--error' : 'form__label'} htmlFor={name}>
            {t('common:fields:couponCode')}
          </label>
          <input
            onChange={(e) => this.handleChange(e.target.value)}
            className={errorMessage ? 'form__input form__input--error' : 'form__input'}
            type="text"
            ref="couponCodeId"
            id="couponCodeId"
          />
        </div>
        {
          errorMessage
            ? <p className="form__errormessage">{errorMessage}</p>
            : ''
        }
        {
          isLoading && <Loader size="small" style={{ marginBottom: '10px' }}/>
        }
        {
          this.state.couponCode && (
            <label className="form__label" style={{ color: 'green', marginBottom: '30px' }}>
              {t('common:fields:foundCouponCode', { couponCodeName: this.state.couponCode.name })}
            </label>
          )
        }
      </div>
    )
  }
}

CouponCodeInputComponent.propTypes = {
  name: string,
  onChange: func
}

export const CouponCodeInput = translate()(view(CouponCodeInputComponent))



// WEBPACK FOOTER //
// ./src/components/ui/inputs/CouponCodeInput.js